// ==== Dependencies

import PropTypes            from 'prop-types';

// ==== Modules

import GoFetch              from '~/js/modules/fetch-wrapper';
import roomsFilter          from '~/js/modules/roomsFilter';
import listGridViewer       from '../seb/includes/list-grid-viewer';
import modal                from '~/js/modules/magnific-popup';
// ==== Component

// import DisplayOptions       from './rooms-suites/DisplayOptions';
import RoomsSuitesContainer from './rooms-suites/RoomsSuitesContainer';

import Header               from './rooms-suites/Header';
import Tabs                 from './rooms-suites/Tabs';
import FilterWrapper        from './rooms-suites/FilterWrapper';
import FeaturePopovers      from './rooms-suites/FeaturePopovers';
import ModalInformation     from './rooms-suites/ModalInfo';
import CardSkeleton         from './rooms-suites/CardSkeleton';

const { Component } = React;
const fetch = new GoFetch();

const internals = {
    filters: {
        roomType: 'ALL',
        views: {},
        features: {},
        specialOffers: {},
    },
    // filtersApplied: {}
};

class RoomsSuites extends Component {

    constructor(props) {
        super(props);

        this.container = React.createRef();
        this._bind(
            'getRooms', 'generateFilterFields', 'onFilterChange', 'updateFilters', 'filterByRoomType',
            'filters', 'toggleGridView', 'filterByRoomViews', 'disableRoomViews', 'resetFilters',
            'filterByRoomFeatures', 'disableRoomFeatures', 'filterBySpecialOffers', 'disableRoomSpecialOffers',
            'scrollToContainer'
        );

        this.state = {
            status: 'loading',
            rooms: [],
            filteredRooms: [],
            filterCount: 0,
            minimumRates: {},
            filters: { ...internals.filters, ...this.props.filters },
            isGrid: false,
            countIcons: 0,
            hasBeenScrolled: false,
            resetButtonVisibility: 'hidden'
        };
    }

    componentDidMount() {
        this.getRooms();
    }

    componentDidUpdate() {

        //  I need to find a better solution
        // listGridViewer();
    }

    // container.current.lastChild refers to the <section> element wrapping the filters, sorry about this.
    // TODO: send this function as prop to filter wrapper and run there, using the right ref from the right element.
    scrollToContainer() {
        const containerOffset = (this.container.current.lastChild.offsetTop);

        window.scrollTo({
            top: (containerOffset - 100),
            behavior: 'smooth'
        });
    }

    getRooms() {
        const url = '/loadRoomData/';
        const params = {
            resortCode: this.props.resortCode
        };

        fetch.post(url, null, params)
            .then(response => {

                const { status } = response;
                const { data = {} } = response;
                const { rooms = [], rates: minimumRates = {} } = data;


                if (status === 'success') {
                    this.generateFilterFields(rooms);

                    const averageRate = this.getAverageRate(minimumRates);

                    this.setState({ rooms, filteredRooms: [ ...rooms ], status, averageRate }, this.roomsDidMount);
                } else {

                    this.setState({ status: 'error' });
                }

            });
    }

    roomsDidMount() {

        listGridViewer();
        roomsFilter();
        modal();
        this.filters();

    }


    filterByRoomType(rooms) {

        const { roomType } = this.state.filters;

        if (roomType === 'ALL') {
            return rooms;
        }

        if (roomType === 'LOVENEST') {

            return rooms.filter(room => room.features.includes('Love Nest'));
        }

        return rooms.filter(room => (room.roomType === roomType));
    }

    filterByRoomViews(rooms) {

        const { views } = this.state.filters;
        const activeViews = [];
        // const inactiveViews = [];

        for(const key of Object.keys(views)) {
            if (views[key].checked && !views[key].disabled) {
                activeViews.push(key);
            }
        }

        if (activeViews.length > 0 ) {
            return rooms.filter(room => {

                let {roomCategoryView = ''} = room;
                let found = null;

                roomCategoryView = roomCategoryView.split(',', roomCategoryView.length);

                found = roomCategoryView.filter(categoryView => {
                    return activeViews.includes(categoryView.trim());
                });

                return found.length > 0 && (activeViews.length === found.length);
            });
        }

        return rooms;
    }

    filterByRoomFeatures(rooms) {

        const { features } = this.state.filters;
        const activeFeatures = [];

        for(const key of Object.keys(features)) {
            if (features[key].checked && !features[key].disabled) {
                activeFeatures.push(key);
            }
        }

        if (activeFeatures.length > 0 ) {
            return rooms.filter(room => {

                let { amenities = {} } = room;
                let found = null;

                amenities = amenities.map(amenity => amenity.roomAmenityName);

                found = amenities.filter(amenity => {
                    return activeFeatures.includes(amenity.trim());
                });

                return found.length > 0 && (activeFeatures.length === found.length);
            });
        }

        return rooms;
    }

    filterBySpecialOffers(rooms) {

        const { specialOffers } = this.state.filters;
        const activeSpecialOffers = [];

        for(const key of Object.keys(specialOffers)) {
            if (specialOffers[key].checked && !specialOffers[key].disabled) {
                activeSpecialOffers.push(key);
            }
        }

        if (activeSpecialOffers.length > 0 ) {
            return rooms.filter(room => {

                let { promotions = ''} = room;
                let found = null;

                promotions = promotions.map(promotion => promotion.promotionTitle);

                found = promotions.filter(specialOffer => {

                    return activeSpecialOffers.includes(specialOffer.trim());
                });


                return found.length > 0 && (activeSpecialOffers.length === found.length);
            });
        }

        return rooms;
    }

    resetFilters() {

        const { views, features, specialOffers, ...restOfFilters } = this.state.filters;
        const [ ...filteredRooms ] = this.state.rooms;
        let filters = null;

        for(const view of Object.keys(views)) {
            views[view].checked = false;
            views[view].disabled = false;
        }

        for(const feature of Object.keys(features)) {
            features[feature].checked = false;
            features[feature].disabled = false;
        }

        for(const specialOffer of Object.keys(specialOffers)) {
            specialOffers[specialOffer].checked = false;
            specialOffers[specialOffer].disabled = false;
        }

        filters = Object.assign({}, filters, restOfFilters, { views, features, specialOffers});

        this.setState({ filters, filteredRooms, filterCount: 0 }, this.toggleResetButton(0));

    }

    disableRoomViews() {
        const [ ...filteredRooms ] = this.state.filteredRooms;
        const { ...views } = this.state.filters.views;
        const initialValue = { uniqueViews: new Set() };

        // let notChecked = null;
        let filters = null;

        let { uniqueViews = [] } = filteredRooms.reduce((acc, room) => {

            acc.uniqueViews = this.getRoomViews(room, acc.uniqueViews);

            return acc;

        }, initialValue);


        uniqueViews = Array.from(uniqueViews);

        for (const key of Object.keys(views)) {
            views[key].disabled = !uniqueViews.includes(key);
        }

        filters = Object.assign({}, this.state.filters, { views });

        this.setState({ filters });

    }

    disableRoomFeatures() {
        const [ ...filteredRooms ] = this.state.filteredRooms;
        const { ...features } = this.state.filters.features;
        const initialValue = { uniqueFeatures: new Set() };

        // let notChecked = null;
        let filters = null;

        let { uniqueFeatures = [] } = filteredRooms.reduce((acc, room) => {

            acc.uniqueFeatures = this.getRoomFeatures(room, acc.uniqueFeatures);

            return acc;

        }, initialValue);


        uniqueFeatures = Array.from(uniqueFeatures);

        for (const key of Object.keys(features)) {
            features[key].disabled = !uniqueFeatures.includes(key);
        }

        filters = Object.assign({}, this.state.filters, { features });

        this.setState({ filters });

    }

    disableRoomSpecialOffers() {
        const [ ...filteredRooms ] = this.state.filteredRooms;
        const { ...specialOffers } = this.state.filters.specialOffers;
        const initialValue = { uniqueSpecialOffers: new Set() };

        // let notChecked = null;
        let filters = null;

        let { uniqueSpecialOffers = [] } = filteredRooms.reduce((acc, room) => {

            acc.uniqueSpecialOffers = this.getRoomPromotions(room, acc.uniqueSpecialOffers);

            return acc;

        }, initialValue);


        uniqueSpecialOffers = Array.from(uniqueSpecialOffers);

        for (const key of Object.keys(specialOffers)) {
            specialOffers[key].disabled = !uniqueSpecialOffers.includes(key);
        }

        filters = Object.assign({}, this.state.filters, { specialOffers });

        this.setState({ filters });

    }

    toggleGridView(isGrid) {
        this.setState({ isGrid }, () => {
            if (!isGrid) {
                modal();
            }
        });
    }

    orderByRates(rooms) {

        return rooms.sort((a, b) => {
            const { rate: rateA = {} } = a;
            const { rate: rateB = {} } = b;

            const { avgRate: avgRateA = 0 } = rateA;
            const { avgRate: avgRateB = 0 } = rateB;

            return avgRateB - avgRateA;
        });
    }

    filters() {

        const [ ...rooms ] = this.state.rooms;
        const filters = {
            roomType: this.filterByRoomType,
            roomView: this.filterByRoomViews,
            roomFeatures: this.filterByRoomFeatures,
            disableRoomViews: this.disableRoomViews,
            // orderByRates: this.orderByRates,
        };
        let filteredRooms = null;
        // const applyThisFilters = ['roomType', 'roomView', 'roomFeatures', 'orderByRates'];
        const applyThisFilters = ['roomType', 'roomView', 'roomFeatures'];
        filteredRooms = applyThisFilters.reduce(( acc, value ) => {

            return this.applyFilter(filters, value, acc);
        }, rooms);


        this.setState({ filteredRooms }, () => {
            this.disableRoomViews();
            this.disableRoomFeatures();

        });
    }

    applyFilter(filters, value, rooms) {

        return filters[value](rooms);
    }

    getAverageRate(minimumRates) {

        const {
            BUTLER = {},
            CLUB = {},
            LUXURY = {},
            loveNest = {},
            lowest = {}
        } = minimumRates;

        const butlerRate = BUTLER.avgRate || 0;
        const clubRate = CLUB.avgRate || 0;
        const luxuryRate = LUXURY.avgRate || 0;
        const loveNestRate = loveNest.avgRate || 0;
        const lowestRate = lowest.avgRate || 0;

        return {
            butlerRate,
            clubRate,
            luxuryRate,
            loveNestRate,
            lowestRate,
        };
    }

    // getPromotions(rooms) {

    //     const uniquePromotions = new Set();

    //     rooms.map(room => {
    //         room.promotions.map( promotion => {
    //             uniquePromotions.add(promotion.promotionTitle);
    //         });
    //     });

    //     return Array.from(uniquePromotions);
    // }

    // getRoomFeatures(rooms) {

    //     const uniqueFeatures = new Set();

    //     rooms.reduce(( featureSet, room ) => {
    //         const { features = [] } = room;

    //         if (features.length > 0) {
    //             featureSet.add(features);
    //         }

    //         return featureSet;

    //     }, uniqueFeatures);

    //     return Array.from(uniqueFeatures);
    // }

    // getRoomView(rooms) {

    //     const uniqueRoomView = new Set();

    //     rooms.reduce(( roomViewSet, room ) => {
    //         const roomCategoryView = room.roomCategoryView.split(',');

    //         if (roomCategoryView.length > 0 || !( roomCategoryView.length === 1 && roomCategoryView[0]) ) {
    //             roomViewSet.add(roomCategoryView);
    //         }

    //         return roomViewSet;

    //     }, uniqueRoomView);

    //     return Array.from(uniqueRoomView);
    // }


    getRoomViews(room, uniqueViews) {

        let { roomCategoryView = '' } = room;

        roomCategoryView = roomCategoryView.trim().split(',');

        for (const view of roomCategoryView) {
            view && uniqueViews.add(view);
        }

        return uniqueViews;
    }

    getRoomFeatures(room, uniqueFeatures) {

        const { amenities: features = [] } = room;


        features.map(feature => uniqueFeatures.add(feature.roomAmenityName) );

        return uniqueFeatures;
    }

    getRoomPromotions(room, uniquePromotions) {

        room.promotions.map( promotion => {
            uniquePromotions.add(promotion.promotionTitle);
        });

        return uniquePromotions;
    }

    getAmenityList(room, uniqueIcons = 0) {

        const { features = [] } = room;

        const amenityList = [
            'rollsRoyceTransfer', 'privateCarTransfer', 'roomService',
            'conciergeService', 'butlerService', 'handicapFriendly',
            'loveNest', 'choicePremiumSpirits', 'premiumSpirits',
            'beerWine', 'airportTransfers'
        ];
        const amenityFeaturedList = ['Free WIFI', 'Soaking Tubs'];

        const iconsFound = [
            ...features.filter(amenity => amenityFeaturedList.includes(amenity)),
            ...amenityList.filter(amenity => room[amenity] === true)
        ];

        return (uniqueIcons < iconsFound.length) ? iconsFound.length : uniqueIcons;

    }

    getRoomFiltersValues(rooms) {

        const initialValue = {
            uniqueView: new Set(),
            uniqueFeatures: new Set(),
            uniquePromotions: new Set(),
            uniqueIcons: 0,
        };


        const uniqueValues = rooms.reduce(( acc, room ) => {

            acc.uniqueView = this.getRoomViews(room, acc.uniqueView);
            acc.uniqueFeatures = this.getRoomFeatures(room, acc.uniqueFeatures);
            acc.uniquePromotions = this.getRoomPromotions(room, acc.uniquePromotions);

            // For Padding between icons
            acc.uniqueIcons = this.getAmenityList(room, acc.uniqueIcons);

            return acc;

        }, initialValue);


        return {
            views: Array.from(uniqueValues.uniqueView),
            features: Array.from(uniqueValues.uniqueFeatures),
            specialOffers: Array.from(uniqueValues.uniquePromotions),
            countIcons: uniqueValues.uniqueIcons,
        };

    }

    generateFilterFields(rooms) {

        const { ...filters } = this.state.filters;
        const {views = [], features = [], specialOffers = [], countIcons = 0} = this.getRoomFiltersValues(rooms);

        // console.log('views', views);
        // console.log('features', features);
        // console.log('specialOffers', specialOffers);

        // ROOM VIEW CHECKBOX
        views.map(view => {
            filters.views[view] = {
                checked: false,
                disabled: false
            };
        });

        // ROOM FEATURES CHECKBOX
        features.map(featuresKey => {
            filters.features[featuresKey] = {
                checked: false,
                disabled: false
            };
        });

        // ROOM SPECIAL OFFERS CHECKBOX
        specialOffers.map(promotion => {
            filters.specialOffers[promotion] = {
                checked: false,
                disabled: false
            };
        });

        this.setState({ filters, countIcons });
    }

    updateFilters(newFilters) {

        const { ...filters } = newFilters;

        this.setState({ filters }, this.filters);
    }

     // On Change
    onFilterChange(event) {

        const target = event.target;
        const name = target.name;
        const value = target.value;

        const { ...filters } = this.state.filters;

        if (target.type === 'checkbox') {
            filters[name][value].checked = target.checked;

            this.countFilters(target.checked);

        } else {

            filters[name] = value;
        }

        this.setState({ filters: filters }, this.filters);

        this.scrollToContainer();
    }

    countFilters(isChecked) {

        let { filterCount } = this.state;

        isChecked ? filterCount++ : filterCount--;

        return this.setState({ filterCount }, this.toggleResetButton(filterCount));
    }

    toggleResetButton(filterCount) {

        const visibility = (filterCount === 0) ? 'hidden' : '';

        return this.setState({ resetButtonVisibility: visibility});
    }

    render() {

        const { uris = {}, resortCode, resortName } = this.props;
        const { filteredRooms, averageRate, status, filters, isGrid, countIcons, resetButtonVisibility } = this.state;

        return (
            <div>
                {/* Top Header */}
                <section className="rooms-suites" ref={this.container}>
                    <div className="rs-banner text-center">
                        <Header resortName={resortName} averageRate={averageRate}/>
                        <Tabs
                            averageRate={averageRate}
                            status={status}
                            filters={ filters }
                            updateFilters={ this.updateFilters }/>
                    </div>

                    <FilterWrapper filters={filters} status={status} rooms={filteredRooms} handleChange={this.onFilterChange} resetFilters={ this.resetFilters } resetButtonVisibility={resetButtonVisibility}/>
                </section>
                {
                    {
                        loading: (
                            <div key="si1" className="list-grid-viewer-section">
                                <div className="container">
                                    <div className="row">
                                        <CardSkeleton />
                                        <CardSkeleton />
                                        <CardSkeleton />
                                    </div>
                                </div>
                            </div>
                        ),
                        error: <h5 key="si3" className="txt-center">Opss! Something Went Wrong!</h5>,
                        success: (
                            <div id="butler-level" className="tab-content fade in active">
                                <section className="list-grid-viewer-section container">

                                    <FeaturePopovers />

                                    <ModalInformation />

                                    <RoomsSuitesContainer
                                        uris={ uris }
                                        roomsFound={ filteredRooms.length }
                                        roomLevel={`Under ${filters.roomType} Level${ filters.roomType === 'ALL' ? 's' : '' }`}
                                        rooms={ filteredRooms }
                                        resortCode={ resortCode }
                                        isGrid={isGrid}
                                        toggleGridView={this.toggleGridView}
                                        countIcons={countIcons}
                                        />

                                </section>
                            </div>
                        )
                    }[status]
                }
            </div>
        );
    }
}

RoomsSuites.propTypes = {
    uris: PropTypes.object,
    resortCode: PropTypes.string,
    resortName: PropTypes.string,
    filters: PropTypes.object,
};

export default RoomsSuites;
